// frontend/src/components/CRSFormSections/PersonalSection.js
import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography
} from '@mui/material';
import {
  BAD_VALUE,
  maritalStatusOptions,
  yesNoOptions,
  ageOptions
} from '../../constants/crsFormOptions'; // Adjust path as needed

function PersonalSection({ formData, handleChange, handleFocus, showSpouseIsPRQuestion, showSpouseAccompanyQuestion }) {
  return (
    <Box sx={{ display: 'grid', gap: 2 }}>
      <Typography variant="h6" sx={{ mt: 2 }}>Personal Information</Typography>

      {/* Marital Status */}
      <FormControl fullWidth required>
        <InputLabel id="marital-status-label">1. What is your marital status?</InputLabel>
        <Select
          labelId="marital-status-label"
          name="maritalStatus"
          value={formData.maritalStatus}
          label="1. What is your marital status?"
          onChange={handleChange}
          onFocus={() => handleFocus('maritalStatus')}
        >
          {maritalStatusOptions.map(option => (
            <MenuItem key={option.value} value={option.value} disabled={option.value === BAD_VALUE}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Spouse is PR? (Conditional) */}
      {showSpouseIsPRQuestion && (
        <FormControl fullWidth required>
          <InputLabel id="spouse-pr-label">2a. Is your spouse/partner a PR or citizen of Canada?</InputLabel>
          <Select
            labelId="spouse-pr-label"
            name="spouseOrPartnerIsPR"
            value={formData.spouseOrPartnerIsPR}
            label="2a. Is your spouse/partner a PR or citizen of Canada?"
            onChange={handleChange}
            onFocus={() => handleFocus('spouseOrPartnerIsPR')}
          >
            {yesNoOptions.map(option => (
              <MenuItem key={option.value} value={option.value} disabled={option.value === BAD_VALUE}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      {/* Spouse Accompanying? (Conditional) */}
      {showSpouseAccompanyQuestion && (
        <FormControl fullWidth required>
          <InputLabel id="spouse-accompany-label">2b. Will your spouse/partner come with you to Canada?</InputLabel>
          <Select
            labelId="spouse-accompany-label"
            name="spouseOrPartnerWillAccompany"
            value={formData.spouseOrPartnerWillAccompany}
            label="2b. Will your spouse/partner come with you to Canada?"
            onChange={handleChange}
            onFocus={() => handleFocus('spouseOrPartnerWillAccompany')}
          >
            {yesNoOptions.map(option => (
              <MenuItem key={option.value} value={option.value} disabled={option.value === BAD_VALUE}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      {/* Age */}
      <FormControl fullWidth required>
        <InputLabel id="age-label">3. How old are you?</InputLabel>
        <Select
          labelId="age-label"
          name="age"
          value={formData.age}
          label="3. How old are you?"
          onChange={handleChange}
          onFocus={() => handleFocus('age')}
        >
          {ageOptions.map(option => (
            <MenuItem key={option.value} value={option.value} disabled={option.value === BAD_VALUE}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}

export default PersonalSection;